interface ContactProps {
  gray?: boolean;
}

export default function Contact({ gray }: ContactProps) {
  return (
    <section
      id="contact"
      className={'section ' + (gray ? 'section--gray' : 'section--paper')}
    >
      <div className="container">
        <div className="contact-wrap">
          <div className="eyebrow">
            <span className="bar" />
            <span>Contact</span>
          </div>
          <h2 className="h2 contact-h2">
            For interviews, media inquiries
            <br />
            or anything else — <span className="red">get in touch.</span>
          </h2>
          <a className="contact-mail" href="mailto:me-pr@mystar.co.jp">
            <span className="contact-mail-label">Group Communications</span>
            <span className="contact-mail-addr">
              me-pr@mystar.co.jp <span className="arr">→</span>
            </span>
          </a>
          <p className="contact-note">
            We respond in English. For Japanese-language inquiries, please see the{' '}
            <a
              href="https://www.mystargroup.jp/"
              target="_blank"
              rel="noreferrer"
              style={{ borderBottom: '1px solid var(--gray-2)' }}
            >
              Japanese site
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
